<template>
  <router-link
    :to="{path: path, params: row}"
    target="_blank">
    {{name}}
  </router-link>
</template>

<script>
  export default {
    name: 'ColumnName',
    props: ['row', 'column'],
    data: () => {
      return {}
    },
    computed: {
      path () {
        return this.row['user'] ? `/users/edit/${this.row.user.id}` : '';
      },
      name () {
        if (!this.row[this.column]) {
          return '';
        }

        const { first_name, last_name, email } = this.row[this.column];

        if (!first_name && !last_name) {
          return email || '';
        }

        return `${first_name} ${last_name}`;
      }
    }
  }
</script>
